export default __webpack_public_path__ + "images/nvent-brand-tracer.png?fc49f83fd3d3c8d26cc29b7a19fc7d53";